import { useEffect } from 'react'
import type { ReactNode } from 'react'

import type { Observer } from '../api/socket'
import { ObserverContext } from './observer-context'

/** Provides the single socket for the tab. */
export function ObserverProvider({
  observer,
  children,
}: {
  observer: Observer
  children: ReactNode
}) {
  useEffect(() => {
    observer.connect()
    // Deliberately not disconnecting on unmount: in React 19's StrictMode the
    // effect runs twice in development, and tearing the socket down between
    // them produces a reconnect storm that looks like a bug in the backend. The
    // socket's lifetime is the tab's, and the tab closing closes it.
  }, [observer])
  return <ObserverContext.Provider value={observer}>{children}</ObserverContext.Provider>
}
